import { useEffect, useState } from "react";

// Shared across any page that needs to swap layout below a breakpoint (DigiTwin's
// BimViewer Siders-vs-Drawers, ProjectSelector's three-column cards-vs-Tabs, etc.)
// instead of each page re-implementing its own matchMedia listener.
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [breakpoint]);
  return isMobile;
}
